import Skeleton from '@mui/material/Skeleton';
import Typography from '@mui/material/Typography';
import React from 'react';
import WizardCard from 'react/signups/card/common/WizardCard';

export default function CardLoading() {
  return (
    <WizardCard>
      <Typography variant="h1">
        <Skeleton animation="wave" />
      </Typography>
    </WizardCard>
  );
}
